<template lang="pug">
  .report
    .flex
      label.fs-17(style="font-weight: bold; grid-column: 1/3; margin-bottom: 10px") opções extras

      PCheckbox(v-model="reportOptions.resignation" :label="`Não considerar ${$wp('employee')} demitidos`")

      PCheckbox(v-model="reportOptions.timelog" :label="`Não considerar ${$wp('employee')} sem pontos no mês`")

      PCheckbox(v-model="reportOptions.merged" label="Gerar resultado em um arquivo")

    .button
      PButton(color="success" size="md" @click="generate" :loading="loading" :disabled="!valid") gerar

</template>

<script>
export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      reportOptions: {
        resignation: false,
        timelog: false,
        merged: false
      }
    }
  },
  methods: {
    getOptions () {
      return this.reportOptions
    },
    async generate () {
      if (!this.valid) return

      this.loading = true

      let result

      try {
        result = await this.$API.R02.save({
          entity: this.reportInfo.entity,
          entityContent: this.reportInfo.entityContent.map(i => i.id),
          compMan: this.$store.state.userInfo.compMan.id,
          ...this.reportOptions,
          ...(
            this.reportInfo.periodData.type === 'period'
              ? {dateStart: this.reportInfo.periodData.startDate, dateEnd: this.reportInfo.periodData.endDate}
              : {year: this.reportInfo.periodData.year, month: this.reportInfo.periodData.month}
          )
        })
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 10px;

  .flex {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }
  .button {
    justify-self: end;
  }
}
</style>
